<template>
  <a-row>
    <a-row>
      <a-col span="20" style="padding-left: 20px">
        <a-select
          allowClear
          show-search
          v-model="textbookId"
          placeholder="搜索教材"
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
          @change="handleChange">
          <a-select-option v-for="textbook in textbookList" :key="textbook.id">
            <a-tag v-if="textbook.status == 0" color="orange">待发布</a-tag>
            <a-tag v-if="textbook.status == 1" color="green">上线</a-tag>
            <a-tag v-if="textbook.status == 2" color="red">下线</a-tag>
            {{ textbook.title }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col span="4" style="text-align: right;padding-right: 20px;">
          <CommonPermissions :p="$permissions.REDEEM_CODE.CREATE">
            <a-button type="primary" @click="() => triggerAddModal()">
              新建
            </a-button>
          </CommonPermissions>
          <a-drawer
            width="80%"
            title="编辑教材"
            placement="right"
            :closable="false"
            :visible="showAddModal"
            @close="() => triggerAddModal()">
              <a-form-model :model="form">
                <a-form-model-item label="教材">
                  <a-select
                    show-search
                    v-model="form.textbookId"
                    placeholder="搜索教材"
                    style="width: 100%"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="handleSearch"
                    @change="handleChange">
                    <a-select-option v-for="textbook in textbookList" :key="textbook.id">
                      <a-tag v-if="textbook.status == 0" color="orange">待发布</a-tag>
                      <a-tag v-if="textbook.status == 1" color="green">上线</a-tag>
                      <a-tag v-if="textbook.status == 2" color="red">下线</a-tag>
                      {{ textbook.title }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="兑换码数量">
                  <a-input-number style="width: 100%" v-model="form.codeNum" />
                </a-form-model-item>
                <a-form-model-item label="备注">
                  <a-input v-model="form.summary" type="textarea" :autoSize="{minRows: 3}"/>
                </a-form-model-item>
                <!-- <a-form-model-item label="分类">
                  <a-cascader :options="textbookCategory" v-model="form.categoryIds" />
                </a-form-model-item> -->
                <a-form-model-item>
                  <CommonPermissions :p="$permissions.REDEEM_CODE.CREATE">
                    <a-button type="primary" @click="saveBatch" :loading="loading">
                      保存
                    </a-button>
                  </CommonPermissions>
                  <a-button style="margin-left: 10px;" @click="() => triggerAddModal()">
                    取消
                  </a-button>
                </a-form-model-item>
              </a-form-model>
          </a-drawer>
      </a-col>
    </a-row>
    <a-table style="margin-top: 10px;" 
      :columns="columns" 
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange">
    <span slot="gmtCreate" slot-scope="text, record">{{ $moment(record.gmtCreate).format('YYYY-MM-DD HH:mm') }}</span>
    <a slot="name" slot-scope="text, record">{{ record.textbook.name }}</a>
    <span slot="action" slot-scope="text, record">
      <CommonPermissions :p="$permissions.REDEEM_CODE.DOWNLOAD">
        <a @click="() => download(record.id)">下载</a>
      </CommonPermissions>
    </span>
    </a-table>
  </a-row>
</template>
<script>
import { mapState } from 'vuex'
import RedeemCodeApi from '../../../api/src/redeem_code/api/RedeemCodeApi'
import TextbookApi from '../../../api/src/textbook/api/TextBookApi'
import CommonPermissions from '@/components/CommonPermissions'
const redeemCodeApi = new RedeemCodeApi()
const textbookApi = new TextbookApi()
const columns = [
  {
    title: '时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    scopedSlots: { customRender: 'gmtCreate' },
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '教材名',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '兑换码数量',
    dataIndex: 'codeNum',
    key: 'codeNum',
  },
  {
    title: '备注',
    dataIndex: 'summary',
    key: 'summary',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: "TextbookEdit",
  components: {
    CommonPermissions,
  },
  data() {
    return {
      columns: columns,
      data: [],
      currentPage: 1,
      showAddModal: false,
      loading: false,
      textbookId: undefined,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 12
      },
      textbookList: [],
      currentTextbookId: undefined,
      form: {
        textbookId: undefined,
        codeNum: undefined,
        summary: undefined
      }
    }
  },
  computed: mapState({
  }),
  created() {
  },
  async mounted() {
    await this.fetchBatch(1)
  },
  methods: {
    async fetchBatch(pageNum, textbookId) {
      this.loading = true
      let resp = await redeemCodeApi.findPagingRedeemCodeBatch(pageNum, {textbookId})
      this.loading = false
      console.log(resp)
      this.data = resp.list
      this.pagination.current = resp.pageNum
      this.pagination.total = resp.total
      this.pagination.pageSize = resp.pageSize
    },
    triggerAddModal() {
      this.showAddModal = !this.showAddModal
      if(!this.showAddModal){
        this.form = {
          textbookId: undefined,
          codeNum: undefined,
          summary: undefined
        }
      }
    },
    async handleChange(value) {
      console.log('handleChange', value)
      if(!this.showAddModal){
        this.currentTextbookId = value
        await this.fetchBatch(1, value)
      }
    },
    async handleSearch(value) {
      console.log('handleSearch', value)
      let resp = await textbookApi.searchTextBook({
        text: value
      })
      console.log(resp)
      this.textbookList = resp
    },
    async handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      await this.fetchBatch(pagination.current, this.currentTextbookId)
    },
    async saveBatch() {
      console.log(this.form)
      this.loading = true
      let resp = await redeemCodeApi.genRedeemCode(this.form)
      this.loading = false
      this.triggerAddModal()
      await this.fetchBatch(1, this.currentTextbookId)
    },
    download(id) {
      console.log(id)
      window.open(`/api/redeem_code/batch/${id}/excel`)
    }
  }
}
</script>

<style lang="less" scoped>

</style>